import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.q{justify-content:center;}.ssr-plugin'
import '.b2{min-height:100vh;}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.p{padding:2rem;}.ssr-plugin'
import '.d{gap:2rem;}.ssr-plugin'
import '.eh{height:3rem;}.ssr-plugin'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { Head } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'

export const MaintenancePage = ({ message }: { message?: string }) => {
  const translations = useTranslations().app

  return (
    <div className="a b c q b2 ah p d"
    >
      <Head>
        <title>CrowdBuilding</title>
      </Head>
      <img className="eh"
        src={fullLogo}
        alt="CrowdBuilding"
      />
      <Text.Large
        style={{
          textAlign: 'center',
          maxWidth: '36rem',
        }}
      >
        {message || translations.landingPage.maintenanceMessage}
      </Text.Large>
    </div>
  )
}
